import React, { useState } from 'react';
import { submitPick } from '../api';
import './PickModal.css';

const PickModal = ({ isOpen, onClose, userId, weekNum, season, onSuccess }) => {
  const [pick, setPick] = useState('');
  const [odds, setOdds] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await submitPick({ weekNum, pick, odds, season });

      if (response.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      }

      if (!response.ok) throw new Error('Failed to save pick. Please try again.');

      onSuccess();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Make Your Pick - {season} Week {weekNum}</h3>
        <h4>{userId}</h4>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Pick:</label>
            <input
              type="text"
              value={pick}
              onChange={(e) => setPick(e.target.value)}
              placeholder="e.g., Patriots -3.5"
              required
            />
          </div>

          <div className="form-group">
            <label>Odds:</label>
            <input
              type="text"
              value={odds}
              onChange={(e) => setOdds(e.target.value)}
              placeholder="e.g., -110"
              required
            />
          </div>

          {error && <div className="error">{error}</div>}

          <div className="modal-buttons">
            <button type="button" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" disabled={loading}>
              {loading ? 'Submitting...' : 'Submit Pick'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PickModal;
